<template>
  <div class="main">
    <!-- <div class="top-box">
      <van-search
        class="search"
        v-model="inputKey"
        show-action
        placeholder="请输入名称"
        @search="onSearch">
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
      <div class="add-box">
        <van-button size="small"  icon="plus" color="#FF6B31" @click="addManager"/>
      </div>
    </div> -->
    <div class="list-wrap">
      <!-- <div class="list-title">管理员名单</div> -->
      <div class="scroll-box">
      <div class="list-title">管理员名单</div>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list v-if="list.length" v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList">
            <div class="card" v-for="item in list" :key="item.id">
              <div class="card-left">
                <van-icon name="user-circle-o" size="46"/>
              </div>
              <div class="card-center">
                <div class="username">{{item.realName}}</div>
                <div class="role">{{item.roleName}}</div>
              </div>
              <div class="card-right">
                <van-image width="25" height="25" :src="deleteImg" @click="deleteManager(item)"/>
              </div>
            </div>
          </van-list>
          <div class="no-data" v-else>
            <van-image width="170px" height="auto" fit="fill" :src="noDataImg" />
            <div>您还未添加管理员</div>
          </div>
        </van-pull-refresh>
      </div>
    </div>
    <div class="add-box">
      <van-button class="button"  text="添加管理员" color="#FF6B31" @click="addManager"/>
     </div>
    <add-manager v-if="isShowAdd" :visible.sync="isShowAdd" @success="onRefresh"/>
  </div>
</template>

<script>
import AddManager from './add-manager'
import loadingMixin from '@/mixins/loading-mixin'
export default {
  name: 'ManagerList',
  mixins: [loadingMixin],
  components: {
    AddManager
  },
  data() {
    return {
      deleteImg: require('@/assets/icons/list_delete.png'),
      noDataImg: require('@/assets/images/img-default@2x.png'),
      inputKey: '',
      searchedKey: '',
      list: [],

      refreshing: false,
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 20,
      isShowAdd: false
    }
  },
  methods: {
    onSearch() {
      this.searchedKey = this.inputKey;
      this.onRefresh();
    },
    getList() {
      // if (this.loading) {
      //   return;
      // }
      // // 将 loading 设置为 true，表示处于加载状态
      // this.loading = true;

      const param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          activityId: this.$route.query.activityId,
          searchKey: this.searchedKey
        }
      }

      this.$api.activityManager.getList(param)
        .then(({data: {list, hasNextPage}}) => {
          if (list && list.length) {
            this.list.push(...list);
          }

          // 当前页的数据小于指定的每页数据
          // this.finished = currentList.length < this.pageSize;
          this.finished = !hasNextPage;
          // 查询下一页
          if (!this.finished) {
            this.pageNum = this.pageNum + 1;
          }
        }).finally(() => {
          this.loading = false;
          this.refreshing = false;
        });
    },
    onRefresh() {
       // 清空列表数据
      this.finished = false;
      this.list = [];
      // 从第一页开始查询
      this.pageNum = 1;
      this.$nextTick(() => {
        this.getList();
      });
    },
    addManager() {
      this.isShowAdd = true;
    },
    deleteManager(item) {
      this.showLoading();
      const params = {
        activityId: this.$route.query.activityId,
        userId: item.id
      };
      this.$api.activityManager.remove(params)
        .then(() => {
          this.isVisible = false;
          this.onRefresh();
        })
        .finally(_ => {
          this.hideLoading();
        });
    }
  },
  created() {
    this.getList();
  }
}
</script>

<style lang="stylus" scoped>
.main
  overflow hidden
  // .top-box
  //   position fixed
  //   left 0
  //   top 0
  //   right 0
  //   z-index 99
  //   display: flex
  //   align-items: center
  //   background-color: #fff
  //   .search
  //     flex 1
  //   .add-box
  //     width: 100%;
  //     flex none
  //     padding 0 10px

  .list-wrap
    // padding-top 54px
    .list-title
      margin 15px 15px 0
      color #999
    .scroll-box
      height: calc(100vh - 100px)
      overflow-y auto
      &::-webkit-scrollbar
        display: none
      >>> .van-pull-refresh
        min-height: 50vh

  .card
    margin 15px
    padding 8px 12px
    display: flex
    align-items: center
    background: #fff
    border-radius: 8px
    &-left
      flex none
      width 55px
    &-right
      flex none
      width 30px
      text-align: center
    &-center
      flex 1

  .username
    font-size 16px
    color #333
  .role
    margin-top 3px
    color #999

  .no-data
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    color #BBBBBB
    font-size 14px
    height 60vh
    line-height: 2
  .add-box 
    position fixed
    display flex;
    justify-content: space-around;
    bottom 0
    width 100%
    height: 84px;
    background: #F3F3F3;
    .button
      width 350px
      height: 43px
      margin-top: 10px
</style>